<template>
  <div class="advice-article">
    <div class="top-nav">
      <v-btn text @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon> Back
      </v-btn>
    </div>
    <div class="advice-article-not-found" v-if="article === 'not found'">Article Not Found</div>
    <div v-if="article && article !== 'not found'">
      <v-img :src="article.image_url_full" height="232"></v-img>
        <div class="advice-article-container">
          <div class="advice-article-title">{{ article.title }}</div>
          <div class="advice-article-date"><strong>Published:</strong> {{ article.date | readDate }}</div>
          <div class="advice-article-body" v-html="article.content"></div>
        </div>
    </div>
  </div>
</template>
<script>

  import { mapState } from 'vuex'
  import moment from 'moment'
  import $ from 'jquery'

  export default {
    mounted() {
      this.$store.commit('articles/SET_ARTICLE', null)
      this.$store.dispatch('articles/loadArticle', this.$route.params.slug)
      //setTimeout(() => {

      this.$store.watch(
              (state) => state.articles.post,
              (newValue, oldValue) => {
                //console.log('watch', newValue, oldValue, this)
                if(typeof YOUTUBE_VIDEO_MARGIN == 'undefined') {
                  var YOUTUBE_VIDEO_MARGIN = 0;
                }
                $('iframe').each(function(index,item) {
                  if($(item).attr('src').match(/(https?:)?\/\/www\.youtube\.com/)) {
                    var w=$(item).attr('width');
                    var h=$(item).attr('height');
                    var ar = h/w*100;
                    ar=ar.toFixed(2);
                    //Style iframe
                    $(item).css('position','absolute');
                    $(item).css('top','0');
                    $(item).css('left','0');
                    $(item).css('width','100%');
                    $(item).css('height','100%');
                    $(item).css('max-width',w+'px');
                    $(item).css('max-height', h+'px');
                    $(item).wrap('<div style="max-width:'+w+'px;margin:0 auto;" />');
                    $(item).wrap('<div style="position: relative;padding-bottom: '+ar+'%; height: 0; overflow: hidden;" />');
                  }
                });

              })


      //}, 10000)
    },
    filters: {
      readDate(date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    computed: {
      ...mapState({
        article: state => state.articles.post
      }),
    }
  }
</script>

<style scoped lang="scss">

  .advice-article {
    width: 100%;
    &-container, &-not-found {
      margin: 20px 30px;
    }
    &-title {
      font-size: 22px;
      font-weight: bold;
      color: $primary;
    }
    &-date {
      font-size: 12px;
      color: grey;
    }
    &-body {
      margin-top: 20px;
      font-size: 14px;
    }


  }
</style>
